import { render } from "./VendorSignUp.vue?vue&type=template&id=4839eb03"
import script from "./VendorSignUp.vue?vue&type=script&lang=js"
export * from "./VendorSignUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__